export enum ThreedViewerMode {
    single = 'single',
    grouping = 'grouping',
    auto = 'auto',
}
